module.exports = __webpack_public_path__ + "static/ssr-diagram-190ee89d11d944a7ce226d97238693e8.png";